import { ROLE_FIELD_EMOJI } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleField/RoleField';
import { TONE_OF_VOICE_CHANNEL_EMOJI } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/ToneOfVoiceFields/ToneOfVoiceChannelField/ToneOfVoiceChannelField';
import { TONE_OF_VOICE_STYLE_EMOJI } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/ToneOfVoiceFields/ToneOfVoiceStyleField/ToneOfVoiceStyleField';
import { TONE_OF_VOICE_RESP_LEN_EMOJI } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/ToneOfVoiceFields/ToneOfVoiceResponseLengthField/ToneOfVoiceResponseLengthField';
import type { PersonaInputData } from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';

import { PlateEditor } from 'src/components/PlateEditor/PlateEditor';

export const AiConfigurationFields = ({
  text = null,
  data = {},
  isFullScreenConfiguration,
}: {
  text?: string | null;
  data?: PersonaInputData;
  isFullScreenConfiguration?: boolean;
}) => {
  return text ? (
    <div className="flex w-full relative overflow-hidden">
      <div className="relative flex flex-col gap-1">
        {isFullScreenConfiguration ? (
          <PlateEditor
            readOnly={true}
            initialValue={text}
            containerClassName={'h-[calc(100%-40px)]'}
            className={'w-full max-w-full h-[calc(100%-40px)]'}
          />
        ) : (
          <div className="relative">
            <p className="max-h-11 font-medium text-sm opacity-70">{text}</p>
            <div className="pointer-events-none absolute bottom-0 left-0 w-full h-1/2 bg-[linear-gradient(180deg,rgba(255,255,255,0)0%,rgba(255,255,255,0.54)50%,rgba(255,255,255,1)100%)]" />
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="flex w-full relative overflow-auto">
      <div className="flex flex-col gap-1">
        <span className="text-sm text-ebony font-semibold">Role</span>
        <span className="text-sm text-ebony opacity-80 font-medium text-nowrap capitalize">
          {`${data.pf_role} ${ROLE_FIELD_EMOJI[data.pf_role] || ''}`}
        </span>
      </div>
      <div className="h-11/12 w-px min-w-px bg-ebony opacity-5 mx-7.5" />
      <div className="flex flex-col gap-1">
        <span className="text-sm text-ebony font-semibold">Channel</span>
        <span className="text-sm text-ebony opacity-80 font-medium text-nowrap capitalize">
          {`${data.pf_tone_of_voice_channel} ${TONE_OF_VOICE_CHANNEL_EMOJI[data.pf_tone_of_voice_channel] || ''}`}
        </span>
      </div>
      <div className="h-11/12 w-px min-w-px bg-ebony opacity-5 mx-7.5" />
      <div className="flex flex-col gap-1">
        <span className="text-sm text-ebony font-semibold text-nowrap">Communication Style</span>
        <span className="text-sm text-ebony opacity-80 font-medium text-nowrap capitalize">
          {`${data.pf_tone_of_voice_style} ${TONE_OF_VOICE_STYLE_EMOJI[data.pf_tone_of_voice_style] || ''}`}
        </span>
      </div>
      <div className="h-11/12 w-px min-w-px bg-ebony opacity-5 mx-7.5" />
      <div className="flex flex-col gap-1">
        <span className="text-sm text-ebony font-semibold text-nowrap">Response length </span>
        <span className="text-sm text-ebony opacity-80 font-medium text-nowrap capitalize">
          {`${data.pf_tone_of_voice_resp_len} ${TONE_OF_VOICE_RESP_LEN_EMOJI[data.pf_tone_of_voice_resp_len] || ''}`}
        </span>
      </div>
    </div>
  );
};
